import Radio from './radio.vue'

Radio.install = function (Vue) {
	Vue.component(Radio.name, Radio);
}

export default Radio;